import {
  CubeReducerState,
  ResolvedPhase
} from 'modules/Cube/domain/cube.domain.types'
import { getAddPhaseAvailable } from 'modules/Cube/domain/postActionStages/queries/availableFeatures/common/getAddPhaseAvailable'
import { getEditCustomerAvailable } from 'modules/Cube/domain/postActionStages/queries/availableFeatures/common/getEditCustomerAvailable'
import { getEditStartDateAvailable } from 'modules/Cube/domain/postActionStages/queries/availableFeatures/common/getEditStartDateAvailable'
import {
  getLinkSalesforceCustomerAvailable,
  getUnlinkSalesforceCustomerAvailable
} from './inspector'
import { getMilestoneBillingAvailable } from './getMilestoneBillingAvailable'
import compose from 'lodash/fp/compose'
import { disableIfLockedByAmendment } from 'modules/Cube/domain/postActionStages/queries/availableFeatures/utils/amendmentLock'
import { hideIfSuperseded } from 'modules/Cube/domain/postActionStages/queries/availableFeatures/utils/quoteSuperseded'

type Context = {
  orderedPhases: ResolvedPhase[]
}
export const getCommonFeaturesAvailable =
  (ctx: Context) =>
  (
    prevState: CubeReducerState
  ): CubeReducerState['queries']['availableFeatures']['common'] => ({
    editCustomer: getEditCustomerAvailable(prevState),
    editStartDate: getEditStartDateAvailable(prevState),
    /**
     * The only one of these either lock refuses. A cancelled schedule refuses it too, and the
     * other three are already impossible on a saved schedule, or are not edits to the quote.
     */
    addPhase: compose(
      disableIfLockedByAmendment(prevState),
      hideIfSuperseded(prevState)
    )(getAddPhaseAvailable(ctx)(prevState)),
    milestoneBilling: getMilestoneBillingAvailable(prevState),
    inspector: {
      linkSalesforceCustomer: getLinkSalesforceCustomerAvailable(prevState),
      unlinkSalesforceCustomer: getUnlinkSalesforceCustomerAvailable(prevState)
    }
  })
